/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";
import "gsap/EasePack";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText);

import Swiper from "swiper";
import {
	// Autoplay,
	// Thumbs,
	// EffectFade,
	Navigation,
	// Pagination,
	Scrollbar,
} from "swiper/modules";


import "../vendors/player/player.js";
import "../vendors/marquee/marquee.js";
import "../vendors/cursor/cursor.js";



/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Default : Smooth scrolling
let scrollSmooth = false;
let debug = false;

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'no-js' body class
	document.body.classList.remove("no-js");
	gsapPreloader();
	scrollDetection(160);
	menuBurger();
	menuDropdown();
	initBanner();
	bannerToMarquee();
	popinInit();
	toggleInit();
	accordionInit();
	swiperInit();
});

// DOCUMENT RESIZED (avec ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerToMarquee();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Activation/désactivation du scroll
function scrollEnabled(bool) {
	if (bool === false || bool === true) {
		const enableScroll = bool === true;

		if (scrollSmooth) {
			scrollSmooth.paused(!enableScroll);
		}

		document.documentElement.style.overflowY = enableScroll ? "auto" : "hidden";
	}
}

// Scroll vers une ancre
function scrollToAnchor(scrollOffset = 0) {

	// Fonction pour gérer le défilement
	const scrollToElement = (target) => {
		const element = document.querySelector(target);
		if (element) {
			if (scrollSmooth) {
				// Avec ScrollSmoother
				scrollSmooth.scrollTo(target, true, `top ${scrollOffset}px`);
			} else {
				// Par défaut
				window.scrollTo({
					top:
						element.getBoundingClientRect().top + window.scrollY - scrollOffset,
					behavior: "smooth",
				});
			}
		}
	};

	// au chargement
	const hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollToElement(hashInUrl);
	}

	// avec un [href="#..."]
	const linksWithAnchor = document.querySelectorAll('a[href^="#"]');
	linksWithAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			const anchorHref = link.getAttribute("href");
			if (anchorHref !== "#") {
				event.preventDefault();
				scrollToElement(anchorHref);
			}
		});
	});

	// avec un [data-scrollto]
	const dataWithScrollTo = document.querySelectorAll("[data-scrollto]");
	dataWithScrollTo.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData === "auto") {
				// Calculer la position de défilement pour 'auto'
				const autoOffset = window.innerHeight + window.scrollY - scrollOffset;
				window.scrollTo({
					top: autoOffset,
					behavior: "smooth",
				});
			} else {
				// Utiliser la valeur de data-scrollto comme cible pour scrollToElement
				scrollToElement(anchorData);
			}
		});
	});
}

// Détection du scroll sur le body
const scrollDetection = (scrollOffset = 0) => {
	let position = window.scrollY;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// Détecter la direction du scroll
		let scroll = window.scrollY;
		// Scroll vers le bas
		if (scroll > position) {
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
				document.querySelector('.title-h0, .title-h1').classList.remove("--animated");
			}
		}
		// Scroll vers le haut
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.querySelector('.title-h0, .title-h1').classList.add("--animated");
				document.body.classList.remove("page-scrolled");
			}
		}
		// Scroll max ?
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
};

// Gestion du menu burger
const menuBurger = () => {
	const headerBurgerButton = document.querySelector("#page-header-burger");
	const headerBurgerArea = document.querySelector("#page-header");

	if (headerBurgerButton) {
		const defaultLogoColor = document.querySelector('.header__navbar__logo svg path').style.fill;
		headerBurgerButton.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
				gsap.set('.header__navbar__logo svg path', { fill:defaultLogoColor });
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
				gsap.set('.header__navbar__logo svg path', { fill:'#377e63' });
			}
		});

		document.addEventListener("mouseup", (event) => {
			if (
				document.body.classList.contains("page-with-fullscreenmenu") &&
				!headerBurgerButton.contains(event.target) &&
				headerBurgerButton !== event.target &&
				!headerBurgerArea.contains(event.target) &&
				headerBurgerArea !== event.target
			) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			}
		});
	}
};

// Gestion des dropdowns
const menuDropdown = () => {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
};

// Activation/désactivation de la bannière
const initBanner = () => {
	// Vérifie si la bannière a déjà été fermée durant cette session
	if (sessionStorage.getItem("bannerClosed") === "true") {
		return;
	}

	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// actualisation
		document.body.classList.add("page-with-banner");
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");

			// Enregistre en session que la bannière a été fermée
			sessionStorage.setItem("bannerClosed", "true");
		});
	}
};

// Gestion du défilement horizontal de la bannière
const bannerToMarquee = () => {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
};

// Gestions des actions des [data-toggle]
const toggleInit = () => {
	// Récupération de tous les écouteurs
	const toggleListeners = document.querySelectorAll("[data-toggle]");

	// Écouteur d'événement pour chaque écouteur
	toggleListeners.forEach((togglelistener) => {
		const toggleTargetSelector = togglelistener.dataset.toggle;
		const toggleTarget = toggleTargetSelector
			? document.querySelector(toggleTargetSelector)
			: null;

		togglelistener.addEventListener("click", (event) => {
			if (toggleTarget) {
				// event.stopPropagation();
				toggleTarget.classList.toggle("--active");
			}
		});
	});

	// Gestionnaire pour les clics hors des éléments toggle
	document.addEventListener("click", (event) => {
		toggleListeners.forEach((togglelistener) => {
			const toggleTargetSelector = togglelistener.dataset.toggle;
			const toggleTarget = toggleTargetSelector
				? document.querySelector(toggleTargetSelector)
				: null;
			if (
				toggleTarget &&
				toggleTarget.classList.contains("--active") &&
				!toggleTarget.contains(event.target) &&
				!togglelistener.contains(event.target)
			) {
				toggleTarget.classList.remove("--active");
			}
		});
	});
};

// Gestions des actions des [data-accordion]
const accordionInit = () => {
	const accordionListeners = document.querySelectorAll("[data-accordion]");

	accordionListeners.forEach((accordionElement) => {
		accordionElement.addEventListener("click", (event) => {
			event.stopPropagation();

			// Retirer la classe "--active" à tous les accordionListeners et accordionTargets
			accordionListeners.forEach((element) => {
				if (element !== accordionElement) {
					const accordionTarget = document.getElementById(
						element.dataset.accordion
					);
					if (accordionTarget) {
						element.classList.remove("--active");
						accordionTarget.classList.remove("--active");
					}
				}
			});

			// Ajouter la classe "--active" à la cible
			if (accordionElement.dataset.accordion) {
				console.log(accordionElement.dataset.accordion)
				const currentaccordionTarget = document.getElementById(
					accordionElement.dataset.accordion
				);
				console.log(currentaccordionTarget)
				if (currentaccordionTarget) {
					accordionElement.classList.add("--active");
					currentaccordionTarget.classList.add("--active");
				}
			}
		});
	});
};

// Gestions des actions des [data-popin]
const popinInit = () => {
	const popins = document.querySelectorAll("[data-popin]");

	popins.forEach((popin) => {
		popin.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popin
			const thispopinName = popin.dataset.popin;
			if (thispopinName) {
				const thispopinEl = document.querySelector(
					`.page__popin#${thispopinName}`
				);
				thispopinEl.classList.toggle("page__popin--open");
			}

			// mettre les vidéos des popins en pause
			const htmlVideoFrompopin =
				document.querySelectorAll(".page__popin video");
			if (htmlVideoFrompopin.length > 0) {
				htmlVideoFrompopin.forEach((video) => {
					video.pause();
				});
			}
		});
	});

	document.addEventListener("mouseup", (event) => {
		// si une popin est ouverte
		if (
			document.querySelectorAll(".page__popin.page__popin--open").length > 0
		) {
			// clic en dehors de la zone
			if (
				!document
					.querySelector(".page__popin .popin__wrapper")
					.contains(event.target) &&
				document.querySelector(".page__popin .popin__wrapper") !== event.target
			) {
				// fermer la popin
				document.querySelectorAll(".page__popin").forEach((popin) => {
					popin.classList.remove("page__popin--open");
				});

				// mettre les vidéos des popins en pause
				const htmlVideoFrompopin =
					document.querySelectorAll(".page__popin video");
				if (htmlVideoFrompopin.length > 0) {
					htmlVideoFrompopin.forEach((popinVideo) => {
						popinVideo.pause();
					});
				}
			}
		}
	});
};

// Convertir les [data-src] en [src]
const srcInit = () => {
	// Select all elements with a data-src attribute
	const srcElements = document.querySelectorAll("[data-src]");
	srcElements.forEach((element) => {
		element.setAttribute("src", element.getAttribute("data-src"));
		element.removeAttribute("data-src");
	});
};

/* -------------------------------- (SWIPER) -------------------------------- */

// Swiper : Initialisation des sliders
function swiperInit() {
	if (
		document.querySelectorAll("#autres-articles .swiper .swiper-slide").length >
		1
	) {
		new Swiper("#autres-articles .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			resizeObserver: true,
			// Modules
			modules: [Scrollbar],
			scrollbar: {
				el: "#autres-articles .swiper-scrollbar",
				draggable: true,
			},
		});
	}

	if ( document.querySelector('#section-realisations')) {
		const homeRealisationsSwiper = new Swiper('#section-realisations .swiper', {
			slidesPerView: 1,
			speed: 1200,
			modules: [Scrollbar, Navigation],
			scrollbar: {
				el: document.querySelector('#section-realisations').querySelector(".swiper-scrollbar"),
				dragSize:window.innerWidth > 992 ? 200 : 'auto',
				draggable: true,
			},
			navigation: {
			  nextEl: document.querySelector('#section-realisations .swiper-button-next'),
			  prevEl: document.querySelector('#section-realisations .swiper-button-prev'),
			},
			breakpoints: {
				992: {
					modules: [Scrollbar],
					scrollbar: false,
				},
			},
		})
		homeRealisationsSwiper.on('slideChange', function (e) {
			const swiperCounter = document.querySelector('#section-realisations .swiper-navigation__count');
			const swiperLength = document.querySelectorAll('#section-realisations .swiper-slide').length;
			swiperCounter.innerHTML = "<span>"+(e.activeIndex + 1)+"</span>/"+swiperLength; 
		});
	}

	if ( document.querySelector('.swiper-realisations')) {
		new Swiper('.swiper-realisations', {
			slidesPerView: 1,
			spaceBetween:40,
			speed: 1200,
			modules: [Scrollbar, Navigation],
			scrollbar: {
				el: document.querySelector('.swiper-realisations').querySelector(".swiper-scrollbar"),
				dragSize:window.innerWidth > 992 ? 200 : 'auto',
				draggable: true,
			},
			navigation: {
			  nextEl: '.swiper-realisations .swiper-button-next',
			  prevEl: '.swiper-realisations .swiper-button-prev',
			},
			breakpoints: {
			  640: {
				slidesPerView: 2,
				spaceBetween: 20,
			  },
			  768: {
				slidesPerView: 3,
				spaceBetween: 40,
			  },
			  1200: {
				slidesPerView: 4,
				spaceBetween: 50,
			  },
			},
		})
	}
}

/* --------------------------------- (GSAP) --------------------------------- */

// GSAP : Initialisation du scrollSmoother (avec ScrollSmoother)
function initScrollSmooth() {
	scrollSmooth = ScrollSmoother.create({
		wrapper: "#page-wrapper",
		content: "#page-container",
		smooth: 1,
		smoothTouch: false,
		effects: window.innerWidth > 992 ? true : false,
		normalizeScroll: false,
		ignoreMobileResize: true,
	});
}

// GSAP : Découpage des textes (avec SplitText)
function gsapSplitText() {
	const textsToAnimated = document.querySelectorAll([
		// global
		'[data-animation^="reveal-text"]',
		'[data-animation^="reveal-chars"]',
		".elementor-heading-title",
		".exerg.elementor-widget-text-editor p",
	]);

	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			tag: "span",
			// type: "lines, words, chars",
			type: "lines, words, chars",
			linesClass: "line",
			wordsClass: "word",
			charsClass: "char",
		});
	});
}

// GSAP : Animations au scroll (avec ScrollTrigger)
function gsapAnimations() {
	// [data-animation] + .elementor-element
	const elementsToAnimated = document.querySelectorAll([
		"[data-animation]",
		".elementor-heading-title",
		".exerg.elementor-widget-text-editor p",
		".elementor-element > .elementor-element > .elementor-element:not([data-animation])",
	]);
	elementsToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	// data-animation="counter"
	const elementsToCounter = document.querySelectorAll(
		'[data-animation="counter"]'
	);
	elementsToCounter.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			// markers: true,
			onEnter: () => {
				setTimeout(() => {
					gsap.from(_this, {
						duration: 1.5,
						textContent: 0,
						snap: { textContent: 1 },
						stagger: {
							each: 1.0,
							onUpdate: function () {
								this.targets()[0].innerHTML = Math.ceil(
									this.targets()[0].textContent
								)
									// conserver les "."
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
									// conserver les espaces
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
							},
						},
					});
				}, delay);
			},
		});
	});

	// data-animation="reveal-text-reading"
	const textsToReading = document.querySelectorAll([
		'[data-animation="reveal-text-reading"]',
	]);
	textsToReading.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		gsap.fromTo(
			_this.querySelectorAll(".word"),
			{
				opacity: 0.33,
			},
			{
				delay: delay,
				stagger: 0.3,
				ease: "power1.out",
				opacity: 1,
				scrollTrigger: {
					trigger: _this,
					start: "top 88%",
					end: "top 22%",
					scrub: true,
					// markers: true,
				},
			}
		);
	});

	// data-animation="skid"
	const elementsToskid = document.querySelectorAll([
		'body:not(.elementor-editor-active) [data-animation="skid"]',
	]);
	elementsToskid.forEach((_this) => {
		gsap.to(_this, {
			scrollTrigger: {
				trigger: _this,
				pin: true,
				pinSpacing: false,
				start: "top top",
				// markers: true,
			},
		});
	});

	// desktop menu animation
	let nav = document.querySelector('.header__navbar__nav');
	let menuWidth = document.querySelector('.header__navbar__menu').getBoundingClientRect().width;
	const menuTl = gsap.timeline({paused:true})
	.to('.header__navbar__menu', { 
		width: menuWidth, 
		ease:'Power4.easeOut', 
		duration:1
	});
	gsap.to('.header__navbar__menu', { width: 0, delay:1, ease:'Power4.easeInOut', duration:1 });
	document.querySelector('.header__navbar__nav').addEventListener('mouseover',()=> {
		nav.classList.add('active');
		menuTl.play();
	})
	document.querySelector('.header__navbar__nav').addEventListener('mouseout',()=> {
		nav.classList.remove('active');
		menuTl.reverse();
	})

	// scroll invite
	if ( document.querySelector('.scroll-invite')) {
		gsap.to('.scroll-invite', { y:0, opacity:1, delay:1 });
	}

	// images fade
	if ( document.querySelector('.text-images')) {

		const textImageTl = gsap.timeline({repeat:-1});
		document.querySelectorAll('.text-images img').forEach((image)=> {
			gsap.set(image, {clipPath:'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)'});
			textImageTl.set(image, {clipPath:'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', zIndex:9});
			textImageTl.to(image, {clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'});
			textImageTl.set(image, {zIndex:1}, '>1');
		})
	}

}

// Actions exécutées après le preLoader d'accueil
function afterPreloader() {
	document.getElementById('page-preloader').remove();
	scrollEnabled(true);
	swiperInit();
	gsapAnimations();
	scrollToAnchor();
}

// GSAP : Rafraîchissement du ScrollSmoother (avec ScrollSmoother)
const gsapScrollSmootherRefresh = () => {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
};

// GSAP : Gestion du preloader d'accueil
const gsapPreloader = () => {
	// Chargement des fonctions GSAP préalables
	initScrollSmooth();
	scrollEnabled(false);
	gsapSplitText();

	// Lancement de l'animation de chargement
	if ( document.querySelector('.home')) {
		const loaderTimeline = gsap.timeline();
		loaderTimeline
			// animation
			.delay(debug ? 1 : 3)
			.to("#page-preloader", {
				duration:.2,
				opacity: 0,
			})
			.set("#page-preloader", {
				visibility: "hidden",
			});

		// Functions succédentes
		loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.1);
	} else {
		afterPreloader();
	}
};

if (document.querySelector('#section-services')) {
	if ( window.innerWidth > 992 ) {
		const services = document.querySelectorAll('#section-services .service');
		const servicesHeight = services.length * window.innerHeight * 2; // * 2 to slow down things
		gsap.set('#section-services', { height:servicesHeight });

		let serviceTimeline = gsap.timeline({paused:true})
		.delay(1);

		gsap.set('#section-services .service .title-h2, #section-services .service .excerpt, #section-services .service__realisation__label, #section-services .service__realisation__title', { opacity:0, y:'10'})
		gsap.set('#section-services .service, #section-services .pin-spacer', {pointerEvents:'none'})

		let currentService = -1;
		services.forEach(function(service, index) {

			serviceTimeline
			.add("service-"+index)
			.set(service.querySelectorAll('a'), {pointerEvents:'all'})
			.to(service.querySelector('.title-h2'), {opacity:1, y:0}, '<-.45')
			.to(service.querySelector('.excerpt'), {opacity:1, y:0}, '<.1')
			.to(service.querySelector('.service__realisation__label'), {opacity:1, y:0}, '<.1')
			.to(service.querySelector('.service__realisation__title'), {opacity:1, y:0}, '<.1')
			.addPause()
			.add("service-end-"+index)
			.set(service, {pointerEvents:'none'})
			.to(service.querySelector('.title-h2'), {opacity:0, y:-10})
			.to(service.querySelector('.excerpt'), {opacity:0, y:-10}, '<')
			.to(service.querySelector('.service__realisation__label'), {opacity:0, y:-10}, '<.1')
			.to(service.querySelector('.service__realisation__title'), {opacity:0, y:-10}, '<.1')

			gsap.set(service, { position:'absolute', top:0 });

			const slideBackground = service.querySelectorAll('.service__image, .service__realisation__image');
			gsap.to(slideBackground,{
				scrollTrigger:{
					trigger:'#section-services',
					start: "top top",
					end: "bottom bottom",
					scrub:true,
					pin:service,
				},
				scale:1,
				ease:'none'
			})
			
			if ( index != 0 ) {
				// console.log("top -"+(window.innerHeight*index), "top -"+(window.innerHeight*(index+1)))
				gsap.set(slideBackground,{clipPath:'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'});
				gsap.to(slideBackground,{
					scrollTrigger:{
						trigger:'#section-services',
						start: "top -"+(window.innerHeight*2*(index-1) + window.innerHeight),
						end: "top -"+(window.innerHeight*2*(index)),
						scrub:true,
						// markers:true,
						onUpdate:(e) => {
							if ( e.progress > .5 ) {
								if ( currentService != index ) {
									// console.log('play '+index);
									serviceTimeline.play("service-end-"+(index-1));
									//serviceTimeline.delay(1).play("service-"+index);
									currentService = index;
									// console.log(e.progress, index);
								}
							}
							if ( e.progress < .5 ) {
								if ( currentService != index-1 ) {
									// console.log('play '+index);
									serviceTimeline.play("service-"+(index-1));
									currentService = index-1;
									// console.log(e.progress, index);
								}
							}
						}
					},
					clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
					ease:'none',
				})
			} else {
				// index = 0;
				ScrollTrigger.create({
					trigger:'#section-services',
					start: "top-="+window.innerHeight/2+" bottom",
					end: "top-="+window.innerHeight/2+" top",
					scrub:true,
					// markers:true,
					onUpdate:(e) => {
						if ( e.progress > .5 ) {
							if ( currentService != index ) {
								serviceTimeline.play("service-"+index);
								currentService = index;
							}
						}
						// console.log(e.progress, index);
					}
				})
			}
			
		})


	}

}

if ( document.querySelector('.poly-images')) {

	gsap.from('.poly-6, .poly-7, .poly-8, .poly-9', {
		scrollTrigger:{
			trigger:'.poly-images',
			start:'top bottom',
			end:'bottom 50%',
			scrub:true,
		}, 
		y:100
	})
	gsap.from('.poly-2, .poly-3, .poly-4, .poly-5', {
		scrollTrigger:{
			trigger:'.poly-images',
			start:'top bottom',
			end:'bottom 50%',
			scrub:true,
		}, 
		y:300
	})
	gsap.from('.poly-1', {
		scrollTrigger:{
			trigger:'.poly-images',
			start:'top bottom',
			end:'bottom 20%',
			scrub:true,
		}, 
		y:400
	})
}







if (document.querySelector('#timeline')) {
	if ( window.innerWidth > 992 ) {
		const services = document.querySelectorAll('.timeline__slides > div');
		const servicesHeight = services.length * window.innerHeight * 2; // * 2 to slow down things
		gsap.set('#timeline', { height:servicesHeight });

		let serviceTimeline = gsap.timeline({paused:true})
		.delay(1);

		gsap.set('#timeline .timeline__slide__title, #timeline .timeline__slide__text, #timeline .timeline__slide__date', { opacity:0, y:'10'})
		gsap.set('#timeline > div, #timeline .pin-spacer', {pointerEvents:'none'})

		let currenDate = -1;
		services.forEach(function(service, index) {

			serviceTimeline
			.add("service-"+index)
			.set(service.querySelectorAll('a'), {pointerEvents:'all'})
			.to(service.querySelector('.timeline__slide__title'), {opacity:1, y:0}, '<-.45')
			.to(service.querySelector('.timeline__slide__text'), {opacity:1, y:0}, '<.1')
			.to(service.querySelector('.timeline__slide__date'), {opacity:1, y:0}, '<.1')
			.addPause()
			.add("service-end-"+index)
			.set(service, {pointerEvents:'none'})
			.to(service.querySelector('.timeline__slide__title'), {opacity:0, y:-10})
			.to(service.querySelector('.timeline__slide__text'), {opacity:0, y:-10}, '<')
			.to(service.querySelector('.timeline__slide__date'), {opacity:0, y:-10}, '<.1')

			gsap.set(service, { position:'absolute', top:0 });

			const slideBackground = service.querySelectorAll('.timeline__slide__image');
			gsap.to(slideBackground,{
				scrollTrigger:{
					trigger:'#timeline',
					start: "top top",
					end: "bottom bottom",
					scrub:true,
					pin:service,
				},
				scale:1,
				ease:'none'
			})
			
			if ( index != 0 ) {
				// console.log("top -"+(window.innerHeight*index), "top -"+(window.innerHeight*(index+1)))
				gsap.set(slideBackground,{clipPath:'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'});
				gsap.to(slideBackground,{
					scrollTrigger:{
						trigger:'#timeline',
						start: "top -"+(window.innerHeight*2*(index-1) + window.innerHeight),
						end: "top -"+(window.innerHeight*2*(index)),
						scrub:true,
						// markers:true,
						onUpdate:(e) => {
							if ( e.progress > .5 ) {
								if ( currenDate != index ) {
									// console.log('play '+index);
									serviceTimeline.play("service-end-"+(index-1));
									//serviceTimeline.delay(1).play("service-"+index);
									currenDate = index;
									console.log(e.progress, index);
									if ( document.querySelector('.timeline__years .active') ) document.querySelector('.timeline__years .active').classList.remove('active');
									document.querySelector('.timeline__years > div:nth-child('+(currenDate + 1) +')').classList.add('active');
								}
							}
							if ( e.progress < .5 ) {
								if ( currenDate != index-1 ) {
									// console.log('play '+index);
									serviceTimeline.play("service-"+(index-1));
									currenDate = index-1;
									console.log(e.progress, index);
									if ( document.querySelector('.timeline__years .active') ) document.querySelector('.timeline__years .active').classList.remove('active');
									document.querySelector('.timeline__years > div:nth-child('+(currenDate + 1 )+')').classList.add('active');
								}
							}
						}
					},
					clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
					ease:'none',
				})
			} else {
				// index = 0;
				ScrollTrigger.create({
					trigger:'#timeline',
					start: "top-="+window.innerHeight/2+" bottom",
					end: "top-="+window.innerHeight/2+" top",
					scrub:true,
					// markers:true,
					onUpdate:(e) => {
						if ( e.progress > .5 ) {
							if ( currenDate != index ) {
								serviceTimeline.play("service-"+index);
								currenDate = index;
							}
						}
						// console.log(e.progress, index);
					}
				})
			}
			
		})
		console.log(window.innerHeight * document.querySelectorAll('.timeline__slide').length)
		gsap.to('.timeline__years',{
			scrollTrigger:{
				trigger:'.timeline__years',
				start: "center 50%",
				end: window.innerHeight * (document.querySelectorAll('.timeline__slide').length ) * 2 + window.innerHeight,
				scrub:true,
				pin:true
			},
		})
	}

}


if ( document.querySelector('.hero-light') ) {
	gsap.set('.header__navbar__logo svg path', {fill:'#377e62'});
}

document.addEventListener("DOMContentLoaded", function() {
	if ( document.querySelectorAll("video[data-src]") ) {
		document.querySelectorAll("video[data-src]").forEach(function(video) {
			video.src = video.dataset.src;
		})
	}
	if ( document.querySelectorAll("img[data-src]") ) {
		document.querySelectorAll("img[data-src]").forEach(function(img) {
			img.src = img.dataset.src;
		})
	}
})